/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createWebhusetOrderApiFeaturesCartCreateResponseFromDiscriminatorValue, serializeWebhusetOrderApiFeaturesCartCreateRequest, serializeWebhusetOrderApiFeaturesCartCreateResponse, type WebhusetOrderApiFeaturesCartCreateRequest, type WebhusetOrderApiFeaturesCartCreateResponse } from '../models/index.js';
// @ts-ignore
import { type WithCartItemRequestBuilder, WithCartItemRequestBuilderNavigationMetadata, WithCartItemRequestBuilderRequestsMetadata } from './item/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /cart
 */
export interface CartRequestBuilder extends BaseRequestBuilder<CartRequestBuilder> {
    /**
     * Gets an item from the OrderApiClient.cart.item collection
     * @param cartId Unique identifier of the item
     * @returns {WithCartItemRequestBuilder}
     */
     byCartId(cartId: string) : WithCartItemRequestBuilder;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<WebhusetOrderApiFeaturesCartCreateResponse>}
     */
     post(body: WebhusetOrderApiFeaturesCartCreateRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<WebhusetOrderApiFeaturesCartCreateResponse | undefined>;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: WebhusetOrderApiFeaturesCartCreateRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const CartRequestBuilderUriTemplate = "{+baseurl}/cart";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const CartRequestBuilderNavigationMetadata: Record<Exclude<keyof CartRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byCartId: {
        requestsMetadata: WithCartItemRequestBuilderRequestsMetadata,
        navigationMetadata: WithCartItemRequestBuilderNavigationMetadata,
        pathParametersMappings: ["cartId"],
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const CartRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: CartRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        adapterMethodName: "send",
        responseBodyFactory:  createWebhusetOrderApiFeaturesCartCreateResponseFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeWebhusetOrderApiFeaturesCartCreateRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
